import { useState, Fragment } from 'react';
import { useNavContext } from '../providers/NavProvider';
import { useScrollContext } from '../providers/ScrollProvider';
import siteData from '../siteData';
import Reveal from './Reveal';
import { handleHashNav } from '../utils/utils';
import logo from '../assets/images/logo/logo.webp';

function Navbar() {
  const [showDrop, setShowDrop] = useState(false);
  const { scrolled } = useScrollContext();
  const { activeSection } = useNavContext();

  function handleCloseNav() {
    setShowDrop(false);
  }

  function handleToggleNav() {
    setShowDrop(!showDrop);
  }

  function titleSize(companyName) {
    const len = companyName.length;
    if (len <= 10) return 'large';
    else if (len <= 15) return 'medium';
    else return 'small';
  }

  return (
    <>
      <nav className={`navbar ${scrolled && 'scrolled'} ${siteData.logo.type.includes('image') && 'has-logo'}`}>
        <Reveal direction="right" order={0} className="left">
          <a href="/#Hero" onClick={handleHashNav('Hero', handleCloseNav)}>
            {siteData.logo.type.includes('image') && (
              <img
                src={logo}
                alt="logo"
                className="logo"
              />
            )}
            {siteData.logo.type.includes('text') && (
              <h1 className={`link ${titleSize(siteData.company.name)}`}>
                {siteData.logo.text.map((seg, i) => (i % 2 === 0 ? <span className="highlight" key={i}>{seg}</span> : `${seg}`))}
              </h1>
            )}
          </a>
        </Reveal>
        <Reveal direction="left" order={0} className="right">
          <ul direction="left" className="nav-links">
            {siteData.sections.map((section, i) => {
              const sectionName = siteData[section.toLowerCase()].alias || section;
              return siteData[section.toLowerCase()].nav && (
                <Fragment key={i}>
                  <li>
                    <a 
                      href={`/#${sectionName}`} 
                      className={`link ${activeSection === sectionName && 'active'}`} 
                      onClick={handleHashNav(sectionName)}
                    >
                      {sectionName}
                    </a>
                  </li>
                  {i !== siteData.sections.length - 1 && <span className="vertical">|</span>}
                </Fragment>
              );
            })}
          </ul>
          <div direction="left" order={1}>
            <button className={`toggle-drop ${showDrop ? 'hide' : 'show'}`} onClick={handleToggleNav}>
              <div className="bar b1" />
              <div className="bar b2" />
              <div className="bar b3" />
            </button>
          </div>
        </Reveal>
      </nav>
      <ul className={`nav-drop ${showDrop ? 'show' : 'hide'} ${scrolled && 'scrolled'} ${siteData.logo.type.includes('image') && 'has-logo'}`}>
        {siteData.sections.map((section, i) => {
          const sectionName = siteData[section.toLowerCase()].alias || section;
          return siteData[section.toLowerCase()].nav && (
            <li key={i}>
              <a
                href={`/#${sectionName}`}
                className={`link ${activeSection === sectionName && 'active'}`}
                onClick={handleHashNav(sectionName, handleCloseNav)}
              >
                {sectionName}
              </a>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default Navbar;